import React, { PropTypes } from "react";
import WindowFunc from "../../ecology9/wea-tools/window";

const LazyRenderBox = React.createClass({
  propTypes: {
    className: PropTypes.string,
    visible: PropTypes.bool,
    hiddenClassName: PropTypes.string
  },
  shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  },
  componentWillReceiveProps(nextProps) {
    if (
      "visible" in nextProps &&
      nextProps.visible &&
      this.props.visible !== nextProps.visible
    ) {
      this.canSetPosition = true;
    } else {
      this.canSetPosition = false;
    }
  },
  canSetPosition: true,
  setPosition(scale) {
    if (
      this.props.role == "document" &&
      ((this.canSetPosition && this.props.visible) ||
        this.props.resize ||
        scale)
    ) {
      const renderBox = $(this.refs.renderBox);
      const modal = renderBox.find(".ant-modal-content");
      let modalHeight = modal.outerHeight();
      let modalWidth = modal.outerWidth();
      let interval = setInterval(() => {
        let topWindow = WindowFunc.getTop();
        if (topWindow !== undefined) {
          this.canSetPosition = false;
          clearInterval(interval);
          let bodyHeight = $(topWindow.document.body).height();
          let bodyWidth = topWindow.document.documentElement.clientWidth;
          let top = Math.floor((bodyHeight - modalHeight) / 2);
          let left = Math.floor((bodyWidth - modalWidth) / 2);
          if (window.setLayoutWindow && window.setDialogFullWindow) {
            const document = window.setLayoutWindow.document;
            let height = $(document.body).height();
            if (height < 550) {
              height = 550;
            }
            bodyHeight = Math.floor(height);
            bodyWidth = Math.floor(document.documentElement.clientWidth);
            top = 0;
            left = 0;
            modal
              .css("height", `${bodyHeight}px`)
              .css("width", `${bodyWidth}px`)
              .css("border-radius", "0");
          }
          renderBox
            .css("top", `${top}px`)
            .css("left", `${left}px`)
            .css("margin", "0")
            .css("visibility", "visible");
        }
      }, 0);
    }
  },
  componentDidMount() {
    this.setPosition();
  },
  componentDidUpdate() {
    this.setPosition();
  },
  render() {
    let className = this.props.className;
    if (this.props.hiddenClassName && !this.props.visible) {
      className += ` ${this.props.hiddenClassName}`;
    }
    const props = { ...this.props };
    delete props.hiddenClassName;
    delete props.visible;
    props.className = className;
    let modalStyle = { ...props.style } || {};
    if (window.setLayoutWindow) {
      modalStyle.height =
        $(window.setLayoutWindow.document.body).height() + "px";
      modalStyle.bodyWidth =
        window.setLayoutWindow.document.documentElement.clientWidth + "px";
    }
    if (props.role == "document") modalStyle.visibility = "hidden";
    return <div ref="renderBox" {...props} style={modalStyle} />;
  }
});

export default LazyRenderBox;



// WEBPACK FOOTER //
// ./_rc-dialog-6.1.1/src/LazyRenderBox.jsx